module.exports = "<header class=\"header\">\n  <div class=\"wrapper\">\n    <h1 class=\"brand\">\n      <a href=\"/\">{{appconfig.labels.header_brand}}</a>\n    </h1>\n  </div>\n</header>"


//////////////////
// WEBPACK FOOTER
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/head/head.component.html
// module id = ../../../../../src/app/head/head.component.html
// module chunks = main